module.exports = __webpack_public_path__ + "img/max-file-configure--pdf.79431623.svg";